module.exports = __webpack_public_path__ + "static/yalda-bottle-18cb79c4d1c76899d5c511405eef98e3.jpg";